import i18next from 'i18next';

import en from './i18n/en';
import es from './i18n/es';

i18next.addResourceBundle('en', 'AccountPopover', en);
i18next.addResourceBundle('es', 'AccountPopover', es);
